var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vee-validation-provider',{ref:"validator",attrs:{"slim":"","name":_vm.name,"rules":Array.isArray(_vm.rules) ? _vm.rules.join('|') : _vm.rules,"custom-messages":_vm.rulesMessages,"mode":_vm.mode},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var classes = ref.classes;
var validate = ref.validate;
return [_vm._t("default",null,{"errors":errors,"classes":classes,"validate":validate})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }